import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';

@Injectable({
    providedIn: 'root'
})
export default class ServiceLevelService {

    constructor(
        private cvApiService: CVApiService
    ) { }

    public async getServiceLevelData(moduleKey: string, isAutoRefresh: boolean = false, isFirstLoad: boolean = false) {
        try {
            const renderEndpoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
            const url = `/api/v2/dashboards/modules/servicelevel/${moduleKey}?isAutoRefresh=${isAutoRefresh}&isFirstLoad=${isFirstLoad}`;
            let response = await this.cvApiService.get<ServiceLevelData>(url, renderEndpoint);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        } catch (err) {
            console.error("Failed getting module render endpoint");
            throw err;
        }
    };
}

export interface ServiceLevelData {
    OutService: number;
    InService: number;
    ServiceLevel: number;
}
